// Tiny module-scoped reactive primitive: tracks window.scrollY via a single
// passive listener, exposes a getter that components can read in runes.
//
// We can't use $state directly in a .ts file outside Svelte's compile scope
// for arbitrary modules, so we keep this here as a .svelte.ts and let any
// component import the getter.

let y = $state(0);

if (typeof window !== 'undefined') {
  window.addEventListener(
    'scroll',
    () => {
      y = window.scrollY;
    },
    { passive: true },
  );
}

export function scrollY(): number {
  return y;
}
